<nav aria-label="Page navigation" *ngIf="totalItems > 0">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1" (click)="setPage(1)">
        <a class="page-link text-white bg-secondary ">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1" (click)="setPage(currentPage - 1)">
        <a class="page-link text-white bg-secondary ">Anterior</a>
      </li>
      <li
        class="page-item"
        *ngFor="let page of pages"
        [class.active]="page === currentPage"
        (click)="setPage(page)"
      >
        <a
          class="page-link"
          [ngClass]="{
            'bg-secondary text-white ': page !== currentPage,
            'bg-white text-danger ': page === currentPage
          }"
        >
          {{ page }}
        </a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages" (click)="setPage(currentPage + 1)">
        <a class="page-link text-white bg-secondary">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages" (click)="setPage(totalPages)">
        <a class="page-link text-white bg-secondary">Última</a>
      </li>
    </ul>
  </nav>
  